/*
 * Get Branches GraphQL specification
 * @module src/graphql/getBranches
 */
/* eslint-disable import/prefer-default-export */
import gql from 'graphql-tag';

export const GET_ACCOUNTS = gql`
  query getAccounts($salesRepId: String, $limit: Int, $filters: AccountFilters) {
    getAccounts(salesRepId: $salesRepId, limit: $limit, filters: $filters) {
      territory
      id
      value: name
      number
      branchId
      isRepStockAccount
      isITorIHAccount
    }
  }
`;
